import classNames from 'classnames'
import { useFormikContext } from 'formik'
import { useRef } from 'react'

import type { PropsWithChildren, ReactElement } from 'react'
import type { IBlockProps, IPageContainerFormValues } from '~/types/template'

import { useOnClickOutside } from '~/hooks/useOnClickOutside'

import './styles.scss'

type BlockType = 'text' | 'title' | 'subtitle' | 'list-text' | 'close-button' | 'navigation'

interface Props extends PropsWithChildren {
  type: BlockType
}

const replaceWithBr = (input: string) => input.replace(/\\N|\\n/g, '<br />')

const SimpleBlock = ({
  children,
  className,
  color,
  onClick,
  properties,
  translation,
  type,
}: IBlockProps & Props): ReactElement => {
  const classes = classNames('block', 'simple-block', `${type}-block`, className)

  const ref = useRef<HTMLInputElement>(null)

  const { setFieldValue } = useFormikContext<IPageContainerFormValues>()

  useOnClickOutside(ref, () => {
    setFieldValue('focus', undefined)
  })

  return (
    <div className={classes} onClick={onClick} ref={ref} style={{ color }}>
      {children || (
        <>
          {translation ? (
            <span dangerouslySetInnerHTML={{ __html: replaceWithBr(translation) }} />
          ) : (
            <span>{properties?.text}</span>
          )}
        </>
      )}
    </div>
  )
}

export default SimpleBlock
